export const ChapData = [
{
    "id":"1",
    "name":"Chapathi ",
    "price":"Price :₹50",
    "image": process.env.PUBLIC_URL + "/assests/chap/1.jpg",
    "description":"Two perfectly rolled, soft wheat chapatis served alongside a rich, aromatic chicken curry slow-cooked with traditional spices."
},
{
    "id":"2",
    "name":"Chapathi with Chicken Gravy",
    "price":"Price :₹60",
    "image": process.env.PUBLIC_URL + "/assests/chap/2.jpg",
    "description":"Two perfectly rolled soft wheat chapatis served with flavorful chicken gravy."
}]